/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 04.06.17.
 */

import React from "react";
import PropTypes from "prop-types";
import TempResourceContainer from "../../TempResourceContainer";
import SchemaValueFormatter from "../../../../SchemaValueFormatter";
import Schema from "../../../../Schema";

class TextViewWidget extends TempResourceContainer {
    static propTypes = {
        schema: PropTypes.object.isRequired,
        id: PropTypes.string.isRequired,
        options: PropTypes.object,
        name: PropTypes.string,
        registry: PropTypes.shape({
            formContext: PropTypes.shape({
                locale: PropTypes.string,
                params: PropTypes.shape({
                    path: PropTypes.string.isRequired,
                    resource: PropTypes.string.isRequired,
                    action: PropTypes.oneOf(["list","new","view","edit","delete"]).isRequired,
                    id: PropTypes.string,
                    query: PropTypes.object,
                    parentPath: PropTypes.string,
                    parentResource: PropTypes.string,
                    parentAction: PropTypes.oneOf(["list","new","view","edit","delete"]),
                    parentId: PropTypes.string,
                    parentField: PropTypes.string
                })
            }).isRequired,
        }),
        value: PropTypes.any,
        className: PropTypes.string
    };

    static defaultProps = {
        className: "form-control-static"
    };

    render() {
        let schema = new Schema(this.props.schema, this.props.options, this.props.name);
        let formatter = new SchemaValueFormatter(schema);
        return (
            <p className={this.props.className} id={this.props.id}>{formatter.format(this.props.value)}</p>
        );
    }
}

export default TextViewWidget;
